(function () {
  'use strict';

  var acceptedPublished = false;

  function analyticsExplicitlyAllowed(privacy) {
    if (
      !privacy ||
      typeof privacy.analyticsProcessingAllowed !== 'function' ||
      typeof privacy.currentVisitorConsent !== 'function'
    ) {
      return false;
    }
    var consent = privacy.currentVisitorConsent();
    return Boolean(
      privacy.analyticsProcessingAllowed() &&
      consent &&
      (consent.analytics === 'yes' || consent.analytics === true)
    );
  }

  function publishAllowedState() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    var allowed = analyticsExplicitlyAllowed(privacy);
    if (allowed && !acceptedPublished) {
      acceptedPublished = true;
      document.dispatchEvent(new CustomEvent('gettmi:consent:accepted'));
    }
    if (!allowed) acceptedPublished = false;
  }

  function init() {
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        function (error) {
          if (!error) publishAllowedState();
        }
      );
    } else {
      publishAllowedState();
    }
  }

  document.addEventListener('visitorConsentCollected', function () {
    window.requestAnimationFrame(function () {
      publishAllowedState();
    });
  });
  document.addEventListener('trackingConsentAccepted', function () {
    window.requestAnimationFrame(function () {
      publishAllowedState();
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
